import { useTranslation } from 'react-i18next'
import { IconButton, Tooltip } from '@mui/material'
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useAppStore } from '@/store/appStore'
import { isImageType } from '@/utils/mediaUtils'

export function MediaGalleryButton() {
  const { t } = useTranslation()
  const { data: bundle } = useContentBundle()
  const setOverlayPage = useAppStore((s) => s.setOverlayPage)

  if (!bundle?.mediaGalleryEnabled || !bundle.media?.some((m) => isImageType(m.mimeType))) return null

  return (
    <Tooltip title={t('mediaGallery.open')} placement="bottom">
      <IconButton
        onClick={() => setOverlayPage({ type: 'media-gallery' })}
        aria-label={t('mediaGallery.open')}
        size="small"
        sx={{
          color: 'var(--color-on-dark-55)',
          '&:hover': { color: 'var(--color-white)', backgroundColor: 'var(--color-on-dark-10)' },
        }}
      >
        <PhotoLibraryIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
